webpackJsonp([17187417236318],{

/***/ 1332:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.consultationPageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\nbackground-color: white;\nheight: 45px;\nwidth: 280px;\n-webkit-appearance: none;\n"], ["\nbackground-color: white;\nheight: 45px;\nwidth: 280px;\n-webkit-appearance: none;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n\tpadding: ", "vw;\n\tpadding-top: 0;\n\tbackground: ", ";\n\n\t@media screen and (max-width: 800px) {\n\t\tflex-direction: column-reverse;\n\t\tjustify-content: center;\n\t\talign-items: flex-start;\n\t}\n\n\tform,\n\t", " {\n\t\tposition: relative;\n\t\tz-index: 99;\n\t}\n"], ["\n\tpadding: ", "vw;\n\tpadding-top: 0;\n\tbackground: ", ";\n\n\t@media screen and (max-width: 800px) {\n\t\tflex-direction: column-reverse;\n\t\tjustify-content: center;\n\t\talign-items: flex-start;\n\t}\n\n\tform,\n\t", " {\n\t\tposition: relative;\n\t\tz-index: 99;\n\t}\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n\tpadding-left: ", "vw;\n\tpadding-right: ", "vw;\n\tmax-width: 500px;\n\n\t@media screen and (max-width: 800px) {\n\t\tmargin-bottom: ", "vw;\n\t}\n\n\t", " {\n\t\tfont-size: 1.75rem !important;\n\t\tline-height: 1.75;\n\n\t\t@media screen and (max-width: 800px) {\n\t\t\tfont-size: 1.25rem !important;\n\t\t\ttext-align: right;\n\t\t}\n\t}\n"], ["\n\tpadding-left: ", "vw;\n\tpadding-right: ", "vw;\n\tmax-width: 500px;\n\n\t@media screen and (max-width: 800px) {\n\t\tmargin-bottom: ", "vw;\n\t}\n\n\t", " {\n\t\tfont-size: 1.75rem !important;\n\t\tline-height: 1.75;\n\n\t\t@media screen and (max-width: 800px) {\n\t\t\tfont-size: 1.25rem !important;\n\t\t\ttext-align: right;\n\t\t}\n\t}\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n\tmargin: 10px;\n\n\tinput,\n\ttextarea {\n\t\tbox-shadow: 0 3px 6px rgba(0, 0, 0, 0.12);\n\t\tresize: none;\n\t\ttransition: ", " ease;\n\t\tborder-radius: 5px;\n\n\t\t&:focus {\n\t\t\tbox-shadow: 0 5px 8px rgba(0, 0, 0, 0.16);\n\t\t\ttransform: scale(1.01);\n\t\t}\n\t}\n"], ["\n\tmargin: 10px;\n\n\tinput,\n\ttextarea {\n\t\tbox-shadow: 0 3px 6px rgba(0, 0, 0, 0.12);\n\t\tresize: none;\n\t\ttransition: ", " ease;\n\t\tborder-radius: 5px;\n\n\t\t&:focus {\n\t\t\tbox-shadow: 0 5px 8px rgba(0, 0, 0, 0.16);\n\t\t\ttransform: scale(1.01);\n\t\t}\n\t}\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(17);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styledFlexComponent = __webpack_require__(23);
	
	var _styledFlexComponent2 = _interopRequireDefault(_styledFlexComponent);
	
	var _evergreenUi = __webpack_require__(24);
	
	var _Typography = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function encode(data) {
		return Object.keys(data).map(function (key) {
			return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
		}).join("&");
	}
	
	var ConsultationPage = function (_Component) {
		_inherits(ConsultationPage, _Component);
	
		function ConsultationPage() {
			_classCallCheck(this, ConsultationPage);
	
			var _this = _possibleConstructorReturn(this, _Component.call(this));
	
			_this.state = {
				sent: false,
				time: "Anytime"
			};
	
			_this.handleChange = function (e) {
				var _this$setState;
	
				_this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
			};
	
			_this.handleSubmit = function (e) {
				fetch("/", {
					method: "POST",
					headers: { "Content-Type": "application/x-www-form-urlencoded" },
					body: encode(_extends({ "form-name": "request-a-consultation" }, _this.state))
				}).then(_this.closeForm()).catch(function (error) {
					return alert(error);
				});
	
				e.preventDefault();
			};
	
			_this.handleChange.bind(_this);
			_this.handleSubmit.bind(_this);
			return _this;
		}
	
		ConsultationPage.prototype.closeForm = function closeForm() {
			this.setState({ sent: true });
		};
	
		ConsultationPage.prototype.render = function render() {
			var post = this.props.data.markdownRemark;
	
			return _react2.default.createElement(
				_react.Fragment,
				null,
				_react2.default.createElement(_reactHelmet2.default, { title: "Contact" }),
				_react2.default.createElement(
					ContactContainer,
					{ full: true, alignCenter: true },
					_react2.default.createElement(
						_styledFlexComponent.FlexItem,
						null,
						_react2.default.createElement(
							_Typography.Title,
							null,
							post.frontmatter.title
						),
						_react2.default.createElement(ContactImage, { resolutions: post.frontmatter.image.childImageSharp.resolutions }),
						this.state.sent ? _react2.default.createElement(
							FormConfirmation,
							null,
							"Thank you. We'll be in touch shortly!"
						) : _react2.default.createElement(
							"form",
							{
								name: "request-a-consultation",
								id: "request-a-consultation",
								method: "POST",
								"data-netlify": "true",
								"data-netlify-honeypot": "bot-field",
								onSubmit: this.handleSubmit },
							_react2.default.createElement("input", { type: "hidden", name: "form-name", value: "request-a-consultation" }),
							_react2.default.createElement(
								"p",
								{ hidden: true },
								_react2.default.createElement(
									"label",
									null,
									"Don\u2019t fill this out: ",
									_react2.default.createElement("input", { name: "bot-field", onChange: this.handleChange })
								)
							),
							_react2.default.createElement(
								FormGrid,
								null,
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(TextInput, {
										required: true,
										type: "text",
										autoComplete: "name",
										name: "full name",
										placeholder: "Your name",
										className: "name",
										onChange: this.handleChange
									})
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(TextInput, {
										required: true,
										type: "email",
										autoComplete: "email",
										name: "email",
										placeholder: "Your email",
										className: "email",
										onChange: this.handleChange
									})
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(TextInput, {
										required: true,
										type: "phone",
										autoComplete: "phone",
										name: "phone",
										placeholder: "Your phone",
										className: "phone",
										onChange: this.handleChange
									})
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(TextInput, {
										required: true,
										type: "date",
										autoComplete: "date",
										name: "date",
										placeholder: "Requested date",
										className: "date",
										onChange: this.handleChange,
										style: { webkitAppearance: "none" }
									})
								),
								_react2.default.createElement(
									SelectContainer,
									null,
									_react2.default.createElement(
										SelectInput,
										{
											required: true,
											type: "select",
											autoComplete: "time",
											name: "time",
											placeholder: "Requested time",
											className: "time",
											onChange: this.handleChange },
										_react2.default.createElement(
											"option",
											{ value: "Anytime", selected: true },
											"Anytime"
										),
										_react2.default.createElement(
											"option",
											{ value: "morning" },
											"Morning"
										),
										_react2.default.createElement(
											"option",
											{ value: "afternoon" },
											"Afternoon"
										),
										_react2.default.createElement(
											"option",
											{ value: "evening" },
											"Evening"
										)
									)
								),
								_react2.default.createElement(
									"p",
									null,
									_react2.default.createElement(TextArea, {
										required: true,
										type: "message",
										autoComplete: "true",
										name: "message",
										placeholder: "Message",
										onChange: this.handleChange
									})
								)
							),
							_react2.default.createElement(
								"p",
								null,
								_react2.default.createElement(
									Button,
									{ name: "submit", type: "Submit", className: "submit", onClick: this.handleSubmit, value: "Submit" },
									"Submit"
								)
							)
						)
					)
				)
			);
		};
	
		return ConsultationPage;
	}(_react.Component);
	
	ConsultationPage.propTypes = {
		data: _propTypes2.default.shape({
			markdownRemark: _propTypes2.default.shape({
				frontmatter: _propTypes2.default.shape({
					title: _propTypes2.default.string
				})
			})
		})
	};
	exports.default = ConsultationPage;
	
	
	var FormGrid = _styledComponents2.default.div.withConfig({
		displayName: "consultation-page__FormGrid"
	})(["display:grid;grid-template-columns:1fr 1fr;grid-gap:0 1rem;@media screen and (max-width:1200px){grid-template-columns:1fr;}"]);
	
	var FormConfirmation = _styledComponents2.default.div.withConfig({
		displayName: "consultation-page__FormConfirmation"
	})(["background:", ";color:white;padding:1rem 2rem;border-radius:5px;z-index:999;position:relative;"], function (props) {
		return props.theme.color.darkGreen;
	});
	
	var TextInput = _styledComponents2.default.input.withConfig({
		displayName: "consultation-page__TextInput"
	})(["width:250px;border:none;padding:10px 15px;outline:none;box-shadow:0 3px 6px rgba(0,0,0,0.12);border-radius:5px;transition:300ms;height:25px;@media screen and (max-width:1200px){width:100%;height:45px;box-sizing:border-box;}}&:focus{box-shadow:0 5px 10px rgba(0,0,0,0.16);}"]);
	
	var SelectContainer = _styledComponents2.default.p.withConfig({
		displayName: "consultation-page__SelectContainer"
	})(["position:relative;&::after{content:\"\";position:absolute;z-index:2;top:24px;margin-top:-3px;height:0;width:0;right:1rem;border-top:6px solid black;border-left:6px solid transparent;border-right:6px solid transparent;pointer-events:none;}"]);
	
	var SelectInput = TextInput.withComponent("select").extend(_templateObject);
	
	var TextArea = _styledComponents2.default.textarea.withConfig({
		displayName: "consultation-page__TextArea"
	})(["width:250px;min-height:100px;border:none;padding:10px 15px;outline:none;box-shadow:0 3px 6px rgba(0,0,0,0.12);border-radius:5px;resize:none;transition:300ms;&:focus{box-shadow:0 5px 10px rgba(0,0,0,0.16);}@media screen and (max-width:1200px){width:100%;box-sizing:border-box;}"]);
	
	var ContactContainer = _styledFlexComponent2.default.extend(_templateObject2, 100 / 24, function (props) {
		return props.theme.gradient.white;
	}, _Typography.Title);
	
	var ContactImage = (0, _styledComponents2.default)(_gatsbyImage2.default).withConfig({
		displayName: "consultation-page__ContactImage"
	})(["position:absolute !important;right:0;bottom:0;transform:translateY(25%) translateX(20%) scale(0.65);opacity:0.65;"]);
	
	var ContactText = _styledFlexComponent.FlexItem.extend(_templateObject3, 100 / 24, 100 / 24 * 3, 100 / 24 * 3, _Typography.SubTitle);
	
	var FieldFlex = _styledFlexComponent.FlexItem.extend(_templateObject4, function (props) {
		return props.theme.animation.normal;
	});
	
	var Button = _styledComponents2.default.button.withConfig({
		displayName: "consultation-page__Button"
	})(["background:", ";color:white;border-radius:7.5px;box-shadow:0 5px 10px rgba(4,135,56,0.3) !important;transition:225ms;font-family:\"Bitter\";border:none;padding:0.5rem 1rem;margin:0.3325rem 0;cursor:pointer;&:hover{box-shadow:0 6px 12px rgba(4,135,56,0.35) !important;transform:scale(1.025);}"], function (props) {
		return props.theme.gradient.green;
	});
	
	var consultationPageQuery = exports.consultationPageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-consultation-page-jsx-a742bbcf03f984addb68.js